import { MoonLoader } from "react-spinners"
import type { CSSProperties } from "react"

const Spinner = (): JSX.Element => {
  const spinnerStyle: CSSProperties = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%"
  }

  return (
    <div style={spinnerStyle}>
      <MoonLoader color="#0d6efd" />
    </div>
  )
}

export default Spinner